import { connect } from 'react-redux'
import { BankDetails } from 'components/Profile'

export default connect(
)(BankDetails)
